/**
 * Shared helpers for the projectServices billing tables.
 *
 * The billing tables (by date, by service, by crew, by job) each total a
 * numeric field across their visible rows for a footer summary row.
 *
 * Contains:
 * - getTotalReducer — Array.reduce callback factory that sums a field,
 *   tolerating missing/null values
 */

import _ from 'lodash';

export const getTotalReducer = field => (reduction, value) => reduction + (_.get(value, field, 0) || 0);
